// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  requestId: __t.u64().primaryKey().name("request_id"),
  holder: __t.identity(),
  settlementId: __t.u64().name("settlement_id"),
  postKey: __t.string().name("post_key"),
  versonaId: __t.u64().name("versona_id"),
  need: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
